// extracted by mini-css-extract-plugin
export default {"container":"ImageBlock_container__Ecl71","big":"ImageBlock_big__ssQqx"};